/**
 * Legal booking status transitions. Encoded as data so both the API and the
 * admin UI can ask "can this move to CANCELLED?" without duplicating an
 * if-chain that will drift.
 */
const TRANSITIONS = {
    /*
     * A reservation waits on the owner of the car before anyone is asked
     * to pay. PENDING may still go straight to CONFIRMED: staff taking a
     * booking at the counter have the owner's answer already, and a paid
     * walk-in should not have to pass through a queue nobody is watching.
     */
    PENDING: ['AWAITING_PAYMENT', 'CONFIRMED', 'CANCELLED'],
    /*
     * Back to PENDING is for a booking whose dates changed after the owner
     * had already accepted: they agreed to *those* dates, so the new ones
     * are a fresh offer and have to go back to them. Staff and partners
     * reach the same edge through the status route, where it reads as
     * "send it back to the owner" — which is a reasonable thing to want.
     */
    AWAITING_PAYMENT: ['CONFIRMED', 'CANCELLED', 'PENDING'],
    CONFIRMED: ['ACTIVE', 'CANCELLED'],
    ACTIVE: ['COMPLETED'],
    COMPLETED: [],
    CANCELLED: [],
};
export function canTransition(from, to) {
    return TRANSITIONS[from].includes(to);
}
export function allowedTransitions(from) {
    return TRANSITIONS[from];
}
/** Free cancellation up to this long before pick-up. */
export const FREE_CANCELLATION_HOURS = 24;
export function cancellationFeeRate(pickupAt, now = new Date()) {
    const hoursToPickup = (new Date(pickupAt).getTime() - now.getTime()) / 3_600_000;
    if (hoursToPickup >= FREE_CANCELLATION_HOURS)
        return 0;
    if (hoursToPickup >= 2)
        return 0.25;
    return 0.5;
}
